module.exports = __webpack_public_path__ + "static/img/customer-service.b484241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customer-service.png
// module id = E68J
// module chunks = 1